import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionsCreators from "actions/agent";
import PageBox from "../public/agentindex";
import { Link } from 'react-router-dom'
import { Form, Input, Button } from "antd";

// import { HomeOutlined } from "@ant-design/icons";
class HotNews extends Component {
  formRef = React.createRef();
  constructor() {
    super();
    this.onFinish = this.onFinish.bind(this);
    this.state = {
      time: 0
    };
  }
  componentDidMount() {
    this.props.getFormContent({ sign: 'street' })
  }

  onFinish(values) {
    let send = { ...values, f_type: 0 };
    let time = 3;
    let t = setInterval(() => {
      if (time <= 0) {
        clearInterval(t);
        this.formRef.current.resetFields();
      }
      this.setState({ time: time-- });
    }, 1000);
    send['f_type'] = '分站申请';
    this.props.apply(send);
  }


  render() {
    return (
      <PageBox>
        <div id="jiamengimg">
          <img src={require('common/img/street1.jpg')} alt="图" />
          <div className="streetbg">
            <div className="wrapper">
            <Form
              name="apply"
              layout="vertical"
              ref={this.formRef}
              onFinish={this.onFinish}
            >
              <Form.Item
                name="f_name"
                rules={[
                  {
                    required: true,
                    message: "单位名称"
                  }
                ]}
              >
                <Input placeholder="请输入单位名称" autoComplete="off" />
              </Form.Item>
              <Form.Item
                name="f_name"
                rules={[
                  {
                    required: true,
                    message: "行业"
                  }
                ]}
              >
                <Input placeholder="请输入行业" autoComplete="off" />
              </Form.Item>
              <Form.Item
                name="f_name"
                rules={[
                  {
                    required: true,
                    message: "职位"
                  }
                ]}
              >
                <Input placeholder="请输入职位" autoComplete="off" />
              </Form.Item>
              <Form.Item
                name="f_phone"
                rules={[
                  {
                    required: true,
                    message: "手机号不能为空"
                  }
                ]}
              >
                <Input placeholder="请输入手机号" autoComplete="off" />
              </Form.Item>
              <Form.Item
                name="f_desp"
              >
                <Input.TextArea placeholder="申请入驻产品" autoComplete="off" rows={4} />
              </Form.Item>
              <Form.Item style={{ marginBottom: 0 }}>
                <Button
                  type="primary"
                  block
                  htmlType="submit"
                  disabled={this.state.time ? true : false}
                >
                  提交{this.state.time ? this.state.time : null}
                </Button>
              </Form.Item>
            </Form>
            </div>
           
          </div>
          <div className="wrapper wrapper2">
          <img src={require('common/img/street3.jpg')} alt="图" />
            <img src={require('common/img/street4.jpg')} alt="图" />
            <img src={require('common/img/street5.jpg')} alt="图" />
          </div>
          <img src={require('common/img/street6.jpg')} alt="图" />
          {/* <div style={{ textAlign: 'right' }} className="wrapper morequestion"><Link to="/help">更多问题 &gt;&gt;</Link></div>
          <Button type="primary" block id="zhaoshangbtn" size="large" onClick={() => { window.scrollTo(0, 700) }}>立即申请</Button> */}
        </div>
      </PageBox>
    );
  }
}

export default connect(
  state => state,
  dispatch => bindActionCreators(actionsCreators, dispatch)
)(HotNews);
